import { COUNTRYCODE } from "@/recourses/constants";
import citiesAddress, { type CityAddress } from "@/utils/citiesAddress";
import { filterCities } from "@/utils/CountriesConfig";
import dayjs from "@/utils/dayjs";

const getAllStores = () => {
  const listStores = filterCities(COUNTRYCODE as CountryCode, true);

  return citiesAddress.filter((item) =>
    listStores.some((store) => store.name?.toLowerCase()?.includes(item.city?.toLowerCase()))
  );
};

export const isOpenForBusiness = (location: CityAddress) => {
  const now = dayjs();
  const dayOfWeek = now.day(); // 0 (Sunday) to 6 (Saturday)
  const currentTime = now.format("HH:mm");

  if (dayOfWeek >= 1 && dayOfWeek <= 6) {
    // Lunes a sábado
    return currentTime >= location.weekdayOpenTime && currentTime <= location.weekdayCloseTime;
  } else if (dayOfWeek === 0) {
    // Domingo
    return currentTime >= location.sundayOpenTime && currentTime <= location.sundayCloseTime;
  }

  return false;
};

export const allStores = getAllStores();
export const cityNames = allStores.map((store) => store.city);
